module.exports = __webpack_public_path__ + "img/lg_ring_r_o_1_null@2x.017d9302.png";